import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { DocumentServiceGateway } from 'src/app/application/gateway/DocumentServiceGateway';
import { DocumentStageGateway } from 'src/app/application/gateway/DocumentStageGateway';
import { OperationDocumentTypeGateway } from 'src/app/application/gateway/OperationDocumentTypeGateway';
import { OperationGateway } from 'src/app/application/gateway/OperationGateWay';
import { AuthUser } from 'src/app/domain/models/AuthUser';
import { DocumentStage } from 'src/app/domain/models/DocumentStage';
import { OperationDocumentGroupByType, OperationDocumentType, OperationInformation, UploadOperationFileRequest } from 'src/app/domain/models/Operation';
import { OperationByStageType, OperationDocument } from 'src/app/domain/models/OperationDocument';
import { Profile } from 'src/app/domain/models/Profile';
import { BasicUser } from 'src/app/domain/models/User';
import { environment } from 'src/environments/environment';
import { OrderUtils } from '../../util/order-utils';
import { faExternalLinkSquare } from '@fortawesome/free-solid-svg-icons';
import { DeliveryService } from 'src/app/application/service/DeliveryService';
import { DeliveryInformation } from 'src/app/domain/models/Delivery';
import { isEmpty } from 'rxjs';
import * as moment from 'moment';
import { DocumentStageClear } from 'src/app/domain/models/DocumentStageClear';

@Component({
  selector: 'app-upload-order-files',
  templateUrl: './upload-order-files.component.html',
  styleUrls: ['./upload-order-files.component.css'],

})
export class UploadOrderFilesComponent implements OnInit, AfterViewInit {

  documentsByDocumentType: OperationDocumentGroupByType[] = []
  documentStages: DocumentStage[] = []
  selectedIndex: number = 0;

  documentsData: OperationByStageType[] = []

  items: MenuItem[] = [];

  profile: BasicUser | undefined
  documents: OperationDocument[] = [];
  documentOperation: OperationInformation | undefined;
  documentsByTypes: OperationDocument[] = [];
  documentTypeName: string = '';
  selectedDocumentStage: DocumentStage | undefined
  documentSelected: OperationDocument | undefined
  clearStages: DocumentStageClear = {
    clearStages: []
  }

  @Input()
  importOrderId: string | undefined

  @Input()
  stageName: string | undefined

  @Input()
  orderDetailNumber: number | undefined

  @Input()
  orderNumber: number | undefined

  @Input()
  directSaleProgramId: number | undefined

  activeStep: number = 0;
  documentTypesPending: number[] = [];
  documentDescription: string = '';

  characterLength: number = 0;
  isExpanded: boolean = false;

  deliveryInformation: DeliveryInformation | undefined
  minDeliveryInformation: {label: string, value: string | number}[] = [];

  @ViewChild('textArea') textArea!: ElementRef;
  visibleEmptyDialog: boolean = false
  loading: boolean = false;
  documentEmptyId: string | undefined
  documentDescriptionForwarder: boolean = false;
  documentDescriptionQCDocument: boolean = false;
  informationLoad: string | undefined
  documentTypeViewId: number | undefined

  uploadedFiles: any[] = []
  name: string = ""
  visibleOperationUploadDialog: boolean = false
  documentRequiredLoad: boolean = false
  showInfo: boolean = false
  operationDocumentTypes: OperationDocumentType[] = []
  extension: string | null = null;

  constructor(
   private documentTypeService: OperationDocumentTypeGateway,
   private documentStageService: DocumentStageGateway,
   private operationService: OperationGateway,
   private authService: AuthGateway,
   private documentService: DocumentServiceGateway,
  public translate: TranslateService,
  private _messageService: MessageService,
  private deliveryService: DeliveryService,
  private _operationDocumentTypeService: OperationDocumentTypeGateway,
  ){
    this.profile = this.authService.getUser()

  }

  ngOnInit(): void {
    this.getStages()
    this.getDeliveryInformation()
    this.loadExportDocumentType()

  }

  ngAfterViewInit(): void {
      this.defaultDocumentShow()
  }


  getStages()
  {
    if(this.profile)
      {
        this.documentStages = []
        this.documentStageService.getAll().subscribe({
          next: (v) => {
            this.documentStages = v
            this.createSteps()
            this.getAllOperationDocuments()
            this.getClearStages()
          },
          error: (e) => {
            this._messageService.add({ severity: 'error',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: this.translate.instant('MessageService.UploadOrderFiles.ManyStagesRetrieveError') });
          }
        })
      }
  }

  createSteps() {
    if(this.documentStages && this.profile)
    {
      this.items = []
      this.documentStages.forEach(x => {
        this.items.push({
          label: this.profile?.lang == 'es' ? x.nameEs : x.name,
          tooltipPosition: 'bottom',
          icon: 'pi pi-check'

        })
      })

    }
  }

  padWithLeadingZeros(id: number): string {
    return OrderUtils.padWithLeadingZeros(id)
  }


  getAllOperationDocuments(findFiles: boolean = true)
  {
     this.operationService.getByImportOrderId(this.importOrderId).subscribe({
        next: (v) => {
            this.documentOperation = v;
            if(findFiles){
              this.defaultDocumentShow()
            }

            this.buildPendingView()

            this.findActiveStep()
        },
        error: (e) => {
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.UploadOrderFiles.ManyRetrieveError') });
        }
     })
  }

  buildPendingView(){
    if(this.profile)
    {
      if(this.profile.type === 1){
        this.buildPendingViewExporterView()
      }else{
        this.buildPendingViewImporterView()
      }
    }
  }

  buildPendingViewExporterView()
  {
    if(this.documentOperation)
    {
      this.documentOperation.documents.forEach(element => {
         if(!element.exporterViewed)
          {
            if(element.operationDocumentTypeId){
              if(!this.documentTypesPending.includes(element.operationDocumentTypeId)){
                this.documentTypesPending.push(element.operationDocumentTypeId)
              }
            }
         }
      });
    }
  }

  buildPendingViewImporterView()
  {
    if(this.documentOperation){
      this.documentOperation.documents.forEach(element => {
         if(!element.importerViewed)
          {
            if(element.operationDocumentTypeId){
              if(this.documentTypesPending.includes(element.operationDocumentTypeId)){
                this.documentTypesPending.push(element.operationDocumentTypeId)
              }
            }
         }
      });
    }
  }

  HasPendingTypes(operationDocumentTypeId: number): boolean
  {
    return this.documentTypesPending.includes(operationDocumentTypeId)
  }

  getPdfSrc(url: string): string
  {
    console.log( environment.apiUrl + "/" + url);
    return environment.apiUrl + "/" + url;
  }

  stageHasPendingTypes(documentStage: DocumentStage): boolean
  {
    let hasPending = false;
    documentStage.documentTypes.forEach((element) => {
        if(this.HasPendingTypes(element.id)){
          hasPending = true;
        }
    });

    return hasPending;
  }

  getStageName(documentStage: DocumentStage)
  {
    if(this.profile)
    {
      return this.profile.lang  == 'es' ? documentStage.nameEs : documentStage.name
    }

    return '';
  }

  getFilesByType(documentTypeId: number, documentType: OperationDocumentType)
  {
    if(this.profile){
      this.documentTypeName  = this.profile.lang === 'es' ? documentType.nameEsChile : documentType.name
    }
    this.documentRequiredLoad = documentType.requiredLoad != null ? documentType.requiredLoad : false;
    this.showInfo = documentType.showInfo;
    this.informationLoad = documentType.informationLoad;

    this.documentsByTypes = []
    this.documentSelected = undefined
    if(this.documentOperation){
      this.documentOperation.documents.forEach((element,index) => {
        // if(index === 0)
        // {

        // }
      if(element.operationDocumentTypeId === documentTypeId)
        {
          if(this.documentSelected)
          {
            if(this.documentSelected.created && element.created){
              if(this.documentSelected.created < element.created){
                this.documentSelected = element
                this.documentDescription = element.description ?? '';
                this.extension = this.getExtension(this.documentSelected.pdfUrl ?? "")
              }
            }

          }else{
            this.documentSelected = element
            this.documentDescription = element.description ?? '';
            this.extension = this.getExtension(element.pdfUrl ?? "")
          }
          this.documentsByTypes.push(element)
         }
      });

      this.changePendingViewed(documentTypeId);
    }

    if(this.documentStages)
    {
      let documentStage = this.documentStages.find(element => {
          return element.id == documentType.documentStageId
      })

      if(documentStage){
        this.selectedDocumentStage = documentStage;
      }
    }

    this.documentTypeViewId = documentTypeId
  }

  searchFilesByType(documentTypeId: number): OperationDocument[]
  {
    let documents: OperationDocument[] = []

    if(this.documentOperation)
    {
      this.documentOperation.documents.forEach((element) => {
        if(element.operationDocumentTypeId === documentTypeId)
        {
          documents.push({...element})
         }
      });

    }

    return documents;

  }


  getTypeName(documentType: OperationDocumentType): string
  {
    if(this.profile){
      return this.profile.lang === 'es ' ? documentType.nameEs : documentType.name
    }

    return ''
  }

  getOperationDocument(documentId: string) {
    this.documentService.getOperationDocument(documentId).subscribe((resultBlob: any) => {
      var downloadURL = window.URL.createObjectURL(resultBlob.body);
      window.open(downloadURL);})
  }

  hasDocument(documentTypeId: number): boolean
  {
    let hasDocument = false;
    if(this.documentOperation)
    {
      this.documentOperation.documents.forEach( element => {
         if(element.operationDocumentTypeId === documentTypeId)
         {
          hasDocument = true;
         }
      });
    }

    return hasDocument;
  }

  findActiveStep(): void
  {
    if(this.documentStages)
      {
        if(this.clearStages.maxStage){
            let index = this.indexStage(this.clearStages.maxStage.id);
            if(index > this.activeStep){
              this.activeStep = index;
            }
        }
    }
  }

  updateDescription(documentId: string, isForwarderDocument: boolean = false, isQcDocument: boolean = false, documentTypeId?: number, documentType?: OperationDocumentType)
  {
    this.loading = true;
    this.operationService.updateDescription(documentId, this.documentDescription, isForwarderDocument, isQcDocument).subscribe({
      next: (v) => {
        this.loading = false;
        if(this.documentSelected)
        {
          this.documentSelected.description = this.documentDescription;
        }
        this.getAllOperationDocuments(false)
        if(documentTypeId && documentType)
        {
          this.getFilesByType(documentTypeId, documentType)
        }

        this._messageService.add({ severity: 'success',
          summary: this.translate.instant('MessageService.Summary.SuccessAction'),
          detail: this.translate.instant('MessageService.UploadOrderFiles.UpdateDescriptionSuccess') });
      },
      error: (e) => {
        this.loading = false;
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.UploadOrderFiles.UpdateDescriptionError') });
        }
    })
  }

  getSelectedDescription(): string
  {
    let description = ''
    if(this.documentSelected)
    {
        var date = this.documentSelected.descriptionUpdate ? moment( this.documentSelected.descriptionUpdate).format('DD/MM/YYYY HH:mm') : "";
        description = this.documentSelected?.description ? this.documentSelected?.description + '-'  + date: ''
    }

    return description;
  }

  formatDate(date: string) {
      return
  }

  emptyDescription()
  {
    if(this.documentEmptyId)
      {
        this.loading = true;
      this.operationService.updateDescription(this.documentEmptyId, '', this.documentDescriptionForwarder, this.documentDescriptionQCDocument).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.UploadOrderFiles.UpdateDescriptionSuccess') });
            this.loading = false;
            this.getAllOperationDocuments()
        },
        error: (e) => {
          this.loading = false;
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.UploadOrderFiles.UpdateDescriptionError') });
          }
      })
    }

  }

  showEmptyDialog(documentId: string, isForwarderDocument: boolean = false, isQcDocument: boolean = false)
  {
      this.documentEmptyId = documentId;
      this.documentDescriptionForwarder = isForwarderDocument
      this.documentDescriptionQCDocument = isQcDocument
      this.visibleEmptyDialog = true;
  }

  getUploadNumber(documentStage: DocumentStage): number
  {
    let uploadTypeNumber: number = 0
    documentStage.documentTypes.forEach(documentType => {
      let hasDocument = false;
      if(this.documentOperation && documentType.requiredLoad)
        {
          this.documentOperation.documents.forEach( element => {
            if(element.operationDocumentTypeId === documentType.id)
            {
             hasDocument = true;
            }
         });
      }

      if(hasDocument)
      {
        uploadTypeNumber++
      }
    })

    return uploadTypeNumber;
  }

  getRequiredUpload(documentStage: DocumentStage): number
  {
    let uploadTypeNumber: number = 0
    documentStage.documentTypes.forEach(documentType => {
      if(documentType.requiredLoad){
        uploadTypeNumber++;
      }
    })

    return uploadTypeNumber;
  }

  indexStage(documentStageId: number): number
  {
      let index = -1;
      if(this.documentStages)
      {
        index = this.documentStages.findIndex( (x) =>
          x.id == documentStageId
        )

        return index;
      }else{
        return index;
      }
  }

  getPercentageNumber(documentStage: DocumentStage):number
  {
    let uploadTypeNumber: number = 0
    documentStage.documentTypes.forEach(documentType => {
      let hasDocument = false;
      if(this.documentOperation)
        {
          this.documentOperation.documents.forEach( element => {
            if(element.operationDocumentTypeId === documentType.id)
            {
             hasDocument = true;
            }
         });
      }

      if(hasDocument){
        uploadTypeNumber++
      }

    })

    return Math.ceil(( uploadTypeNumber / documentStage.documentTypes.length ) * 100);
  }

  defaultDocumentShow()
  {
    if(this.documentStages && this.documentOperation)
    {
      let type = this.documentStages[0].documentTypes.find(element => {
        return this.hasDocument(element.id)
      })

      if(type){
        this.getFilesByType(type.id, type)
      }
    }
  }

  changePendingViewed(documentTypeId: number)
  {
    if(this.importOrderId){
      this.operationService.hasPendingViewsStage(documentTypeId, this.importOrderId).subscribe({
        next: (v) => {
           let index = this.documentTypesPending.findIndex((element)=> {
                  return element === documentTypeId
           });

           if(index != -1){
            this.documentTypesPending.splice(index, 1);
           }
        },
        error: (v) => {
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.UploadOrderFiles.ChangeViewError') });
        }
      })
    }

  }

  expandAccordion(documentStageId: number): void{

    if(this.documentStages)
    {
    this.documentStages.forEach( (x, index) => {
      if(x.id != documentStageId){
        this.documentStages[index].selected = 0;

      }else{
        this.documentStages[index].selected = 1;
      }
    }
      )

    }
  }

  changePdfSrc(document: OperationDocument){
     this.documentSelected = document;
     this.extension = this.getExtension(document.pdfUrl ?? "");
     console.log(this.extension)
     console.log("entra")

  }

  getExtension(path: string): string | null {
  const match = path.match(/\.([^.?#]+)(?:[?#]|$)/);
  return match ? match[1] : null;
  }

  getDocumentDescription(documentTypeId: number): string
  {

    let description = '';
    if(this.documentOperation)
    {
      let documents = this.searchFilesByType(documentTypeId);
      documents.forEach( (element, index) =>
      {
        if(element.operationDocumentTypeId == documentTypeId && index == 0)
        {
          description = element.description ?? '';
        }
     });
    }
    return description
  }

  getDeliveryInformation()
  {
    if(this.importOrderId){
      this.deliveryService.getByImportOrderId(this.importOrderId).subscribe({
        next: (v) => {
          this.deliveryInformation = v;
        },
        error: (e) => {
          let errorMessage = ''
            const lang = this.translate.currentLang
            switch(lang) {
              case 'es':
                errorMessage = e.error.messageEs
                break
              case 'en':
                errorMessage = e.error.messageEn
                break
              default:
                errorMessage = this.translate.instant('MessageService.Delivery.SingleRetrieveError')
          }
          this._messageService.add({
            severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: errorMessage
          });
        }
      })
    }

  }


  upload(){
    this.loading = true

    if(!this.uploadedFiles[0])
    {
      this.loading = false;
      this._messageService.add({ severity: 'error',
        summary:this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('UploadDocumentDialog.LoadDocumentMessage') })

    }else{
      const uploadFileRequest: UploadOperationFileRequest = {
        orderId: this.importOrderId,
        name: this.name,
        pdf: this.uploadedFiles[0],
        operationDocumentTypeId: this.documentTypeViewId
      }
      this.operationService.uploadFile(uploadFileRequest).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('UploadDocumentDialog.UploadDocumentSuccess') })
            this.getStages()
            this.getDeliveryInformation()
          this.loading = false
          this.visibleOperationUploadDialog = false;
        },
        error: (e) => {
          this.loading = false
          console.log(e)
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('UploadDocumentDialog.UploadDocumentError') });
        },
        complete: () => {
          this.loading = false
        }
      })
    }
  }

  onSelect(event: any) {
    this.uploadedFiles = []
    for(let file of event.files) {
        this.uploadedFiles.push(file);
    }

    if(event.files[0])
      this.name = event.files[0].name
  }

  onSelectDocumentType(event: any) {
    this.documentTypeViewId = event.value
  }

  hasInformationLoad(informationLoad: string, requireLoad: boolean): boolean
  {
      if(this.deliveryInformation && !requireLoad)
      {
        switch (informationLoad) {
          case 'container_number':
            return this.deliveryInformation.delivery.containerNumber != null
          case 'deposit':
            return this.deliveryInformation.delivery.containerDeposit != null
          case 'sag':
            return this.deliveryInformation.delivery.dus != null
          case 'truck':
            return (
              this.deliveryInformation.delivery.departurePatentTruck != null ||
              this.deliveryInformation.delivery.departurePatentCar != null ||
              this.deliveryInformation.delivery.truckDriverName != null
            )
          default:
            return false;
        }
      }

      return false;
  }

  loadExportDocumentType() {
    this.operationDocumentTypes =  []
    this.loading = true;
    this._operationDocumentTypeService.getAll().subscribe({
      next: (v) => {
        this.operationDocumentTypes = v
        this.loading = false
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.ExportOfferDocument.ManyRetrieveError') });
        console.log(e)
        this.loading = false
      },
      complete: () =>  {
        this.loading = false
        console.info('Operation Document types query successfully')
      }
    })
  }

  getClearStages()
  {
    if(this.importOrderId)
    {
      this.loading = true;
      this.operationService.getClearStages(this.importOrderId).subscribe({
        next: (v) => {
          this.clearStages = v;
          this.loading = false;
        },
        error: (e) => {
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.UploadOrderFiles.ClearStageRetrieveError') });
          this.loading = false
        },
      })
    }

  }

  isClearStage(documentStageId: number)
  {
      let index = this.clearStages.clearStages.findIndex((x) => x == documentStageId);

      if(index != -1 ){
        return true;
      }else{
        return false;
      }
  }
}
